import { render } from "./ChartsAlarmConfiger.vue?vue&type=template&id=68d39084&scoped=true"
import script from "./ChartsAlarmConfiger.vue?vue&type=script&lang=js"
export * from "./ChartsAlarmConfiger.vue?vue&type=script&lang=js"

import "./ChartsAlarmConfiger.vue?vue&type=style&index=0&id=68d39084&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d39084"]])

export default __exports__